import React, {useContext, useEffect} from 'react'
import {Grid, FormControl, InputLabel, MenuItem, Select, FormHelperText} from '@material-ui/core'
import {ReservationConfigurationContext} from './../../../context/ReservationConfiguration'
export default function WMemoField({data, onChange, tabActive}) {
  const {entityObjects, loadEntityObjects} = useContext(ReservationConfigurationContext)

  useEffect(() => {
    if (
      data?.list_limit_attributes?.length === 0 ||
      data?.list_limit_attributes === null ||
      data?.list_limit_attributes === undefined
    ) {
      loadEntityObjects(data?.description)
    }
  }, [data, loadEntityObjects])
  return (
    <Grid item xs={6}>
      <FormControl fullWidth variant="outlined" className="ap-textfield" style={{width: 320}}>
        <InputLabel id="demo-mutiple-name-label">{data.name}</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          label={data.name}
          value={data.value || []}
          onChange={e => {
            onChange(e, data.key)
          }}
          multiple
        >
          {data?.list_limit_attributes?.length
            ? data?.list_limit_attributes?.map(f => {
                return <MenuItem value={f}>{f}</MenuItem>
              })
            : entityObjects?.data?.objects?.map(o => {
                return <MenuItem value={o.id}>{o.display_name}</MenuItem>
              })}
        </Select>
        <FormHelperText>
          {(() => {
            if (
              (tabActive === 'upcoming' && data.is_required) ||
              (tabActive === 'ongoing' && data.is_required_return)
            ) {
              return 'required*'
            } else {
              return 'optional'
            }
          })()}
        </FormHelperText>
      </FormControl>
    </Grid>
  )
}
